import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {Product} from 'src/app/product-details/interface/product';
import {VolumeDiscountProfile} from 'src/app/product-details/interface/volume-discount-profile';
import {JWTService} from "../../../../authentication/jwt.service";
import {PreOrderVolumeDiscountCalculationService} from '../service/pre-order-volume-discount-calculation.service';
import {VolumeDiscountProfileItem} from 'src/app/product-details/interface/volume-discount-profile-item';
import {GlobalService} from 'src/app/services/global.service';
import {BloomsightService} from "../../../../bloomsight.service";

@Component({
	selector: 'fb-pre-order',
	templateUrl: './pre-order.component.html',
	styleUrls: ['./pre-order.component.scss']
})
export class PreOrderComponent implements OnChanges {

	@Input() productData: Product = {} as Product;
	public productDataContainer: Product = {} as Product;
	@Output() imageTransfetDisplayImage = new EventEmitter<string>();
	@Output() preOrderClose: EventEmitter<boolean> = new EventEmitter<boolean>();

	public volumeDiscountProfile: VolumeDiscountProfile | undefined = {} as VolumeDiscountProfile
	public isUserLoggedIn: boolean = false;
	public preOrderQty = 0;
	public preOrderDeliveryFromDate = 0;
	public preOrderDeliveryToDate = 0;

	public isPreOrderPriceShow: boolean = false;
	public volumeDiscountclose: boolean = false;
	public isCustomizationOpen: boolean = false;
	public isThisProductFabric: boolean = false;
	public isAnimationStopped: boolean = false;

	constructor(
		private _jwt: JWTService,
		private _cartCalculation: CartCalculationService,
		private _preOrderVolumeDiscountCalc: PreOrderVolumeDiscountCalculationService,
		private _bloomsight: BloomsightService,
		public _globalService: GlobalService,
	) {
	}

	ngOnChanges() {
		this.isCustomizationOpen = this.productData.productGroup === 'finished';
	}

	public openVolumeDiscount(): void {
		this.volumeDiscountclose = true;
		this._globalService.popUpOpenClose(true);
	}

	public updateImageToDisplay(evt: string): void {
		this.imageTransfetDisplayImage.emit(evt)
	}

	public addToCartPreOrder(): void {
		this.preOrderClose.emit(false)
		this._cartCalculation.isPreorder = true;
		this._bloomsight.trackDataEvent(
			'65f035fefe3931befe4c47b9',
			{sku: this.productData.sku},
			''
		);
		this._cartCalculation.calculateCart();

	}

	public ngOnInit(): void {
		this.isUserLoggedIn = this._jwt.hasValidJWT();

		// debugger
		this._cartCalculation.isPreorder = true;
		this.productDataContainer = this.productData;

		this.calculateDeliveryDate();
	}

	public preOrderQTYPassOn(preOrderQTY: number) {
		// debugger
		this.preOrderQty = preOrderQTY;
		this.isPreOrderPriceShow = false;
		setTimeout(() => {
			this.isPreOrderPriceShow = true;
		});

	}

	public calculateDeliveryDate(): void {

		this._preOrderVolumeDiscountCalc.passedVolumeDiscount.subscribe(
			(passedVolumeDiscount: VolumeDiscountProfileItem) => {

				this.preOrderDeliveryFromDate = this._preOrderVolumeDiscountCalc.preorderEstimateDeliveryDateCalc(passedVolumeDiscount.deliveryFromDays);

				this.preOrderDeliveryToDate = this._preOrderVolumeDiscountCalc.preorderEstimateDeliveryDateCalc(passedVolumeDiscount.deliveryToDays);
			})
	}

	public triggerCustomizeOption(): void {
		this.isAnimationStopped = true;
		this.isCustomizationOpen = !this.isCustomizationOpen;
	}

}
